<template>
  <div>
    <div class="table-responsive">
      <table class="table m-0 p-0 dataTable min-h-[150px] text-nowrap">
        <thead class="bg-white">
          <tr>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Name
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Warehouse Manager
            </th>
            <th
              class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              width="20%"
            >
              Location
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Status
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Created
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Actions
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-if="loading">
            <td colspan="12" class="text-center">
              <div
                class="text-center"
                style="padding-top: 100px; padding-bottom: 50px"
              >
                <span
                  class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                  style="font-size: 8rem"
                ></span>
                <h3
                  class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px"
                >
                  Please wait while we load your distributor's list
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="l in Locations" :key="l.id" v-else>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              <span v-if="l.name">{{ l.name }}</span>
              <span v-if="l.code">({{ l.code }})</span>
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ l.manager ? l.manager.displayName : "N/A" }}
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ l.address && l.address }} {{ l.state ? l.state : "N/A" }}
            </td>
            <td>
              <span
                class="flex items-center gap-[4px] max-w-max w-full"
                :class="[
                  'badge',
                  { 'badge-success': l.active, 'badge-danger': !l.active },
                ]"
              >
                <span
                  class="w-[10px] h-[10px] rounded-[1px]"
                  :style="{ backgroundColor: l.active ? '#16a249' : '#EF5253' }"
                ></span>
                <span class="text-[12px] font-normal leading-[16.94px]">{{
                  l.active ? "Active" : "Inactive"
                }}</span>
              </span>
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ formatDate(l.created) }}
            </td>
            <td>
              <button
                class="btn-no-border"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span
                  class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                >
                  ...
                </span>
              </button>
              <ul
                class="dropdown-menu shadow-none"
                aria-labelledby="dropdownMenuButton"
              >
                <li
                  class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                  v-if="
                    hasPermission('Inventory_Location_Update') &&
                      l.parentId == user.parentId
                  "
                  @click.prevent="viewEdit(l)"
                >
                  Edit
                </li>
                <li
                  class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                  href="#"
                  v-if="hasPermission('Inventory_Location_Delete')"
                  style="color: red"
                  @click.prevent="confirmDelete(l.id)"
                >
                  Delete Warehouse
                </li>
              </ul>
            </td>
          </tr>
          <tr v-if="!Locations.length && !loading">
            <td colspan="6">
              <div class="text-center" style="padding-top: 50px">
                <span
                  style="font-size: 4.615rem"
                  class="mdi mdi-crosshairs-gps"
                ></span>
              </div>
              <h3 class="text-center" style="padding-bottom: 100px">
                You don't have any warehouses.
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :limit="pageSize"
        :count="pageCount"
        :page="page"
        :itemsCount="count"
        @changePage="gotoPage"
        @changeLimit="changeLimit"
      />
    </div>
    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-add"
      role="dialog"
    >
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Create new warehouse
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.name }]"
                  type="text"
                  v-model="createLocation.name"
                  placeholder="Enter warehouse name"
                />
                <ul v-if="v1.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehouse Manager</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="isBusy"
                  v-model="createLocation.managerId"
                >
                  <option
                    v-for="p in warehouseManagers"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.displayName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Code</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  v-model="createLocation.code"
                  placeholder="Enter warehouse code"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >State</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="isBusy"
                  v-model="createLocation.state"
                >
                  <option v-for="(s, i) in states" :key="i" :value="s">
                    {{ s }}
                  </option>
                </select>
                <ul v-if="v1.state" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Address</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  v-model="createLocation.address"
                  placeholder="Enter warehouse address"
                />
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max mt-[16px]"
              @click="createLocation.active = !createLocation.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="createLocation.active"
                :class="{
                  'bg-[#2463eb]': createLocation.active,
                  'bg-[#E4E4E7]': !createLocation.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': createLocation.active,
                    'translate-x-0 bg-gray-400': !createLocation.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This warehouse is active
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="create"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add warehouse</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-edit" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Edit warehouse
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  :class="[{ 'is-invalid': v2.name }]"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                  type="text"
                  v-model="updateLocation.name"
                />
                <ul v-if="v2.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehouse Manager</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="isBusy"
                  v-model="updateLocation.managerId"
                >
                  <option
                    v-for="p in warehouseManagers"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.displayName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Code</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                  type="text"
                  v-model="updateLocation.code"
                />
                <!-- <ul v-if="v2.code" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul> -->
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >State</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="isBusy"
                  v-model="updateLocation.state"
                >
                  <option v-for="(s, i) in states" :key="i" :value="s">
                    {{ s }}
                  </option>
                </select>
                <ul v-if="v2.state" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Address</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                  type="text"
                  v-model="updateLocation.address"
                />
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max mt-[16px]"
              @click="updateLocation.active = !updateLocation.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="updateLocation.active"
                :class="{
                  'bg-[#2463eb]': updateLocation.active,
                  'bg-[#E4E4E7]': !updateLocation.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': updateLocation.active,
                    'translate-x-0 bg-gray-400': !updateLocation.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This warehouse is active
                </span>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
              @click="cancel"
            >
              Cancel
            </button>
            <button
              style="width: 100px"
              :disabled="isBusyModal"
              class="btn btn-primary"
              type="button"
              @click.prevent="update"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Status</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.status"
                >
                  <option value="0">All warehouses</option>
                  <option value="True">Active</option>
                  <option value="False">Disabled</option>
                </select>
              </div>
            </div>

            <div class="pb-[10px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Other filters</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by code or name..."
                  v-model="filter.qry"
                />
              </div>
            </div>

            <div class="pb-[16px]">
              <div class="col-12 col-sm-8 col-lg-8">
                <label
                  class="custom-control custom-checkbox custom-control-inline"
                >
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    v-model="filter.showForMe"
                  />
                  <span class="custom-control-label">My warehouses Only</span>
                </label>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="getLocations"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteWarehouse"
      :isBusy="isBusyModal"
      text="warehouse"
      message="Deleting this warehouse will delete associated storage areas. Click DELETE to proceed."
    />
    <GeneralDeleteMessage
      message="You cannot delete this warehouse because there is an inventory or reconcile order transaction history associated with it."
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import GeneralDeleteCaution from "../GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../GeneralDeleteMessage.vue";
import Select2 from "@/components/Select2";
import Pagination from "../Pagination.vue";
import SystemPermissions from "@/permissions";
import { bus } from "../../main";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsLocations",
  components: {
    Pagination,
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
  },
  created() {
    if (!this.hasPermission("Inventory_Location_View")) {
      this.$router.push("/restricted");
    }
    this.getLocations();
    this.getWarehouseManagers();
    bus.$on("viewAddLoaction", this.viewAdd);
    bus.$on("viewAddFilter", this.viewFilter);
  },
  watch: {},
  data() {
    return {
      filter: {
        status: "0",
        qry: "",
        showForMe: false,
      },
      isBusy: false,
      loading: false,
      isBusyModal: false,
      warehouseManagers: [],
      states: helper.getStates(),
      createLocation: {
        code: "",
        managerId: "",
        state: "",
        address: "",
        name: "",
        active: "",
      },
      updateLocation: {
        code: "",
        name: "",
        managerId: "",
        state: "",
        address: "",
        active: true,
        id: "",
      },
      editLocation: {
        code: null,
        managerId: null,
        state: null,
        address: null,
        name: null,
        active: true,
        id: null,
      },
      v1: {
        code: false,
        state: false,
        name: false,
      },
      v2: {
        code: false,
        state: false,
        name: false,
      },
      Locations: [],
      DeleteId: "",
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    reset() {
      this.page = 1;
      this.filter = {
        status: "0",
        qry: "",
        showForMe: false,
      };
    },

    cancel() {
      const currentLocation = this.Locations.find(
        (l) => l.id === this.editLocation.id
      );

      currentLocation.code = this.editLocation.code;
      currentLocation.name = this.editLocation.name;
      currentLocation.state = this.editLocation.state;
      currentLocation.address = this.editLocation.address;
      currentLocation.managerId = this.editLocation.managerId;
      currentLocation.id = this.editLocation.id;
      currentLocation.active = this.editLocation.active;

      $("#mod-edit").modal("hide");
    },

    async getWarehouseManagers() {
      this.isBusy = true;

      await this.$http
        .get("/Users/getWarehouseManager/")
        .then(function(res) {
          this.warehouseManagers = res.body;
          this.isBusy = false;
        })
        .catch(function() {});
      this.isBusy = false;
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },

    viewAdd() {
      this.createLocation = {
        code: "",
        name: "",
        managerId: "",
        state: "",
        address: "",
        active: false,
      };
      this.v1 = {
        code: false,
        name: false,
        state: false,
      };
      $("#mod-add").modal("show");
    },

    viewEdit(c) {
      var editValues = {
        code: c.code,
        name: c.name,
        managerId: c.managerId,
        state: c.state,
        address: c.address,
        active: c.active,
        id: c.id,
      };
      this.editLocation = editValues;
      this.updateLocation = c;
      $("#mod-edit").modal("show");
    },

    viewFilter() {
      this.page = 1;
      $("#mod-filter").modal("show");
    },

    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteWarehouse() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(
          `/Locations/delete/${this.DeleteId}`
        );
        if (res.ok) {
          this.$toast.success("Warehouse deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getLocations();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        code: this.createLocation.code,
        name: this.createLocation.name,
        managerId: this.createLocation.managerId,
        state: this.createLocation.state,
        address: this.createLocation.address,
        active: this.createLocation.active,
        parentId: this.user.parentId,
      };

      if (this.validateCreate()) {
        await this.$http
          .post("/Locations/create", data)
          .then(function(res) {
            this.isBusyModal = false;
            $("#mod-add").modal("hide");
          })
          .catch(function() {});

        this.getLocations();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateCreate() {
      this.v1 = {
        code: false,
        name: false,
        state: false,
      };
      var isValid = true;

      if (!this.createLocation.name) {
        this.v1.name = true;
        isValid = false;
      }

      if (!this.createLocation.state) {
        this.v1.state = true;
        isValid = false;
      }

      return isValid;
    },

    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        code: this.updateLocation.code,
        name: this.updateLocation.name,
        managerId: this.updateLocation.managerId,
        state: this.updateLocation.state,
        address: this.updateLocation.address,
        active: this.updateLocation.active,
        id: this.updateLocation.id,
        parentId: this.user.parentId,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .put("/Locations/update/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});

        this.getLocations();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateUpdate() {
      this.v2 = {
        name: false,
        state: false,
      };
      var isValid = true;

      if (!this.updateLocation.name) {
        this.v2.name = true;
        isValid = false;
      }

      if (!this.updateLocation.state) {
        this.v1.state = true;
        isValid = false;
      }

      return isValid;
    },

    async getLocations() {
      this.isBusy = true;
      if (this.filter.qry) {
        this.page = 1;
      }
      this.loading = true;
      await this.$http
        .get(
          "/Locations/getList?page=" +
            (this.page - 1) +
            "&pageSize=" +
            this.pageSize +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            (this.filter.showForMe != ""
              ? "&showForMe=" + this.filter.showForMe
              : "")
        )
        .then(function(res) {
          this.Locations = res.body.data;
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
        })
        .catch(function() {
          this.loading = false;
        });
      $("#mod-filter").modal("hide");
      this.isBusy = false;
      this.loading = false;
    },

    appendNameCode(name, code) {
      return code ? `${name} (${code})` : `${name}`;
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    prev() {
      this.page -= 1;
      this.getLocations();
    },

    next() {
      this.page += 1;
      this.getLocations();
    },

    gotoPage(page) {
      this.page = page;
      this.getLocations();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getLocations();
    },
  },
};
</script>
